import { useRecoilValue } from "recoil";
import { insetState } from "../../../recoil/inset";
import {
  CertSurveyBottomButton,
  CertTitle,
  CertUsedPubButton,
  CertUsedPubButtonWrapper,
  CertWrapper,
} from "./styles/cert";
import { enqueueSnackbar } from "notistack";

interface StepProps {
  certUsedPub: boolean | null;
  setCertUsedPub: (usedPub: boolean | null) => void;
  onNext: () => void;
}

const StepCertUsedPub = ({
  certUsedPub,
  setCertUsedPub,
  onNext,
}: StepProps) => {
  const inset = useRecoilValue(insetState);
  const handleNext = () => {
    if (certUsedPub === null) {
      enqueueSnackbar("홀덤펍 이용 경험을 알려주세요!", {
        variant: "error",
      });
      return;
    }

    onNext();
  };
  return (
    <CertWrapper isApp={inset}>
      <CertTitle>
        홀덤펍을 이용해본 적이
        <br />
        있나요?
      </CertTitle>

      <CertUsedPubButtonWrapper>
        <CertUsedPubButton
          isSelected={certUsedPub}
          onClick={() => setCertUsedPub(true)}
        >
          네, 이용해봤어요!
        </CertUsedPubButton>
        <CertUsedPubButton
          isSelected={certUsedPub === false}
          onClick={() => setCertUsedPub(false)}
          style={{
            marginTop: "8px",
          }}
        >
          아니요, 처음이에요
        </CertUsedPubButton>
      </CertUsedPubButtonWrapper>
      <CertSurveyBottomButton
        isSelected={certUsedPub !== null}
        onClick={() => handleNext()}
      >
        다음
      </CertSurveyBottomButton>
    </CertWrapper>
  );
};

export default StepCertUsedPub;
